export const isEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

const normalizeEmail = (email) => email.trim().replaceAll(' ', '');

export const normalizeEmailsFromArray = (emails) => emails.map((email) => normalizeEmail(email));

export const normalizeEmailFromData = (data) => {
  const { email } = data;

  if (!email) return data;

  return {
    ...data,
    email: normalizeEmail(email),
  };
};
